import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import Verify from './pages/Verify';
import HODDashboard from './pages/HODDashboard';

function getUser() {
  try { return JSON.parse(localStorage.getItem('user')); }
  catch { localStorage.removeItem('user'); return null; }
}

function RequireRole({ roles, children }) {
  const user  = getUser();
  const token = localStorage.getItem('token');
  if (!user || !token) {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    return <Navigate to="/" replace />;
  }
  if (!roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"              element={<Login />} />
        <Route path="/dashboard"     element={<RequireRole roles={['admin','content_author']}><AdminDashboard /></RequireRole>} />
        <Route path="/verify"        element={<RequireRole roles={['content_author']}><Verify /></RequireRole>} />
        <Route path="/hod-dashboard" element={<RequireRole roles={['hod']}><HODDashboard /></RequireRole>} />
        <Route path="*"              element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;